// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCloud_faculty-profile-word-map__MUylQ {
  margin-bottom: 30px;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
@media only screen and (max-width: 900px) {
  .KeywordCloud_faculty-profile-word-map__MUylQ {
    padding: 0;
    box-shadow: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/KeywordCloud/KeywordCloud.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AACF;AACE;EANF;IAOI,UAAA;IACA,gBAAA;EAEF;AACF","sourcesContent":[".faculty-profile-word-map {\n  margin-bottom: 30px;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n\n  @media only screen and (max-width: 900px) {\n    padding: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-profile-word-map": `KeywordCloud_faculty-profile-word-map__MUylQ`
};
export default ___CSS_LOADER_EXPORT___;
